import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileMp3"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 6.75H16.5V8.25H21V11.25H18V12.75H21V15.75H16.5V17.25H21C21.8284 17.25 22.5 16.5784 22.5 15.75V8.25C22.5 7.42157 21.8284 6.75 21 6.75ZM10.5 17.25H9V6.75H13.5C14.3284 6.75 15 7.42157 15 8.25V12C15 12.8284 14.3284 13.5 13.5 13.5H10.5V17.25ZM10.5 12H13.5V8.25H10.5V12ZM6 6.75L4.8675 10.5L4.5 11.985L4.155 10.5L3 6.75H1.5V17.25H3V11.25L2.88 9.75L3.315 11.25L4.5 14.7225L5.685 11.25L6.12 9.75L6 11.25V17.25H7.5V6.75H6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileMp3.vue"]]);
